import { authQueryClient, setupAxiosAuthErrors } from '@metto/http-clients/api';
import { Outlet, useRouter } from '@tanstack/react-router';

const RootLayout = () => {
  const router = useRouter();

  setupAxiosAuthErrors(() => {
    // Crash landing! Eject everything!
    authQueryClient.clear();
    router.clearCache();

    router.navigate({ to: '/sign-in' });
  });

  return <Outlet />;
};

export default RootLayout;
